// Společné živé spojení pro celý web (kromě Terminalu, který má vlastní): ws/terminal/?mode=lite&markets=sp,oil.
// Každou zprávu z Redisu rozešle jako událost `mx:live` {channel, market, message}; poslouchá ji obnovování
// stránek (live.js) a notifikace (notify.js). Trhy a nastavení jsou v <div id="mx-live"> z base.html.
const MARKET_OF = {
  'news:updates': 'sp', 'sentiment:updates': 'sp',
  'oil:news:updates': 'oil', 'oil:sentiment:updates': 'oil',
};
export const isNews = (channel) => channel === 'news:updates' || channel === 'oil:news:updates';

export function initSocket() {
  const cfg = document.getElementById('mx-live');
  if (!cfg || cfg.dataset.ownSocket === '1' || !('WebSocket' in window)) return;
  let retry = 0;
  const connect = () => {
    const proto = location.protocol === 'https:' ? 'wss' : 'ws';
    let ws;
    try {
      ws = new WebSocket(`${proto}://${location.host}/ws/terminal/?mode=lite&markets=${encodeURIComponent(cfg.dataset.markets || 'sp')}`);
    } catch { return; }
    ws.onopen = () => { retry = 0; };
    ws.onmessage = (e) => {
      try {
        const msg = JSON.parse(e.data);
        const market = MARKET_OF[msg.channel];
        if (market) window.dispatchEvent(new CustomEvent('mx:live', { detail: { channel: msg.channel, market, message: msg.message || {} } }));
      } catch { /* neplatná zpráva */ }
    };
    ws.onclose = () => { retry += 1; setTimeout(connect, Math.min(30e3, 2e3 * retry)); };
  };
  connect();
}
